<template>
<div class="card card-dashboard-thirteen" style="height:460px" v-loading='loading'>
  <div class='media'>
        <div class='media-body'>
          <label class="az-content-label" style="font-size:13px;font-weight:800">Brand Value Distribution</label>
        </div>
        <div class='media-body'>
          <el-input 
          style='margin-bottom:5px'
          size='mini'
          v-model="message" 
          prefix-icon="el-icon-search"
          placeholder="Search">
          </el-input>
        </div>
      </div>
  <el-row type="flex" class="mg-t-20 mg-b-20">
    <el-col :span="10" style="height:325px;margin-left:5px">
      <span class="d-block mg-b-20 az-content-text"> You have <span style="color:black"><strong>{{brands.length}}</strong></span> brands. Click the brand names to see Adviser Dashboard</span>
      <ul class="brand-list">
          <li class='mg-b-15' v-for="(brand,index) in brands" :key="brand.brand_code">
              <div class="tx-medium" v-show="brand[1].toLowerCase().match(message.toLowerCase())">
                  <span style="margin-right:10px;color:white" :style="{backgroundColor:colorList[index]}" class="badge"  >{{index+1}}</span><router-link @click.native='selectBrand(brand)' :to="{path:'/adviserdashboard/'}">{{brand[1]}}</router-link>
              </div>
          </li>
      </ul>
    </el-col>
    <el-col :span="14" class="pd-t-60">
      <FirmValueDistribution v-if="isChartShow" :bo_values = 'bo_values'/>
    </el-col>
  </el-row>
</div>
</template>
<script>
// import axios from 'axios';
export default {
  name: 'firms',
  components: { 
    FirmValueDistribution : () => import('../charts/FirmValueDistribution.vue'),
  },
  props: {
    
  },
  data(){
    return{
      brands:[],
      message:'',
      bo_values:[],
      colorList:[           
        '#8ECAE6','#4895EF','#4361EE','#3F37C9',                                    
        '#6247aa','#815ac0','#9381ff','#b8b8ff','#cbc0d3',
        '#efd3d7','#eee2df'                                        
      ],
      isChartShow:false,
      loading:true,
    }
  },
  
  beforeCreate(){
    
  },
  created(){
    this.getFirms();
  },
  methods:{
    getFirms: function(){
        let userdetail = JSON.parse(localStorage.getItem('userdetail'));
        this.brands = userdetail['brand_list'];
        this.$api.bo_api.bo_values(this.brands[0][0]).then(response =>{
            this.bo_values = this.getChartData(response.data["bo_values"])
            this.isChartShow=true
            this.loading=false
        })
    },
    getChartData(obj){
        let array = []
        for(let key in obj){
            array.push(Object.assign({value:obj[key]}, {name: key}))
        }
        console.log(array)
        return array
    },
    selectBrand: function(brand_selected){
      this.$store.dispatch('select_brand',brand_selected)
    }
  }
}
</script>
